<template>
  <div class="list-container">
    <div class="list-header">
      <h4>{{ title }}</h4>
    </div>
    <div class="logo">
      <img
        :src="require(`@/assets/${logo}`)"
        :alt="logoAltText"
      >
    </div>
    <div
      v-if="state === status.LOADING"
      class="loading"
    >
      <property-list-skeleton />
    </div>
    <div
      v-if="state === status.EMPTY"
      class="empty"
    >
      <h2>No Properties Found</h2>
    </div>
    <div
      v-if="state === status.MATCHED"
      class="empty"
    >
      <div class="checkmark mb-5">
        <v-icon
          color="success"
          size="23px"
          style="vertical-align: bottom;  height: 100%; width: 100%;"
        >
          $faCheck
        </v-icon>
      </div>
      <h2>All Properties Matched</h2>
    </div>
    <div
      v-if="state === status.MATCHING"
      class="px-4"
    >
      <div class="search-properties mb-5 pr-3">
        <v-text-field
          solo
          flat
          dense
          color="#929292"
          label="Filter by Name"
          prepend-inner-icon="$faSearch"
          @input="val => $emit('search', val)"
        >
          <template #prepend-inner>
            <v-icon
              size="16"
              color="#929292"
            >
              $faSearch
            </v-icon>
          </template>
        </v-text-field>
      </div>
      <p class="unmatched-count">
        <v-icon
          color="#E69F00"
          size="16px"
          left
          style="vertical-align: bottom;"
        >
          $faExclamationTriangle
        </v-icon>
        {{ properties.length || 0 }} unmatched properties
      </p>
      <v-virtual-scroll
        height="250"
        item-height="80"
        bench="1"
        :items="properties"
        class="list-scroll-container"
      >
        <template v-slot:default="{ index: idx, item: property }">
          <div
            :key="idx"
            class="property-item d-flex align-center justify-center"
            @click="handleSelected(property.id)"
          >
            <v-card
              v-ripple
              :color="selected === property.id ? '#50847B' : '#F1EDE6'"
              :class="selected === property.id ? 'selected' : ''"
              class="my-auto"
              width="100%"
              height="auto"
            >
              <v-card-title>
                <div class="matched-header d-flex justify-space-between">
                  <span class="prop-name">{{ property.name }}</span>
                  <span class="prop-id">ID: {{ property.id }}</span>
                </div>
              </v-card-title>
              <v-card-text
                :style="`color: ${selected === property.id ? '#FFFFFF' : '#000000'};`"
                class="prop-address"
              >
                {{ property.address }}
              </v-card-text>
            </v-card>
          </div>
        </template>
      </v-virtual-scroll>
    </div>
  </div>
</template>

<script>
  import PropertyListSkeleton from './PropertyListSkeleton.vue'
  import status from '@/helpers/property-matching-status'

  export default {
    name: 'PropertyList',
    components: { PropertyListSkeleton },
    props: {
      properties: {
        type: Array,
        default: () => ([]),
      },
      title: {
        type: String,
        default: '1. Select a Property',
      },
      logo: {
        type: String,
        default: 'noiseaware-logo-small.png',
      },
      logoAltText: {
        type: String,
        default: 'NoiseAware Logo',
      },
      selected: {
        type: Number,
      },
      state: {
        type: String,
        default: status.LOADING,
      },
    },
    computed: {
      status () { return status },
    },
    methods: {
      handleSelected (target) {
        const payload = this.selected === target ? null : target
        this.$emit('update:selected', payload)
      },
    },
  }
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 490px;
  padding: 0px;
  background: #F9F7F3;
  box-shadow: 3px 4px 25px rgba(80, 132, 123, 0.25);
  border-radius: 4px;
  .list-header {
    background: #395453;
    border-radius: 4px 4px 0px 0px;
    h4 {
      color: #ffffff;
      font-size: 20px;
      line-height: 27px;
      letter-spacing: 1px;
      padding: 10px 21px;
    }
  }
  .logo {
    width: auto;
    height: 74px;
    padding: 23px 0px;
    img {
      display: block;
      margin: 0 auto;
      width: 166px;
      height: auto;
    }
  }
  .empty {
    position: relative;
    top: 10%;
    text-align: center;
    .checkmark {
      width: 74px;
      height: 74px;
      background: #F1EDE6;
      border-radius: 50%;
      display: block;
      margin: 0 auto;
    }
    h2 {
      font-family: Degular;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 40px;
      letter-spacing: 1px;
      color: #929292;
    }
  }
  .loading {
    width: 100%;
    padding: 0 24px;
  }
  .unmatched-count {
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #3C3333;
    display:flex;
    align-items:center;
  }
  .list-scroll-container {
    position: relative;
    height: 250px;
    margin-right: -10px;
    padding: 10px 20px 0px 0px;
    overflow-y: auto;
    .property-item {
      cursor: pointer;
      >div:hover {
        background-color: $success !important;
        color:white !important;
        .prop-address {
          color:white !important;
        }
      }
    }
    .matched-header {
      width:100%;
      font-size: 15px;
      line-height:18px;
      .prop-name {
        font-weight: 700;
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .prop-id {
        white-space: nowrap;
      }
    }
    .prop-address {
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    .selected {
      color: white;
    }
  }
}
</style>
